module.exports = __webpack_public_path__ + "static/media/bg_progress.70a1aa55.svg";